export function createSatFormaPago() {
  return {
    EmpresaId: 0,
    CFormaPago: '',
    Descripcion: '',
    Bancarizado: '',
    NumeroDeOperacion: '',
    RfcEmisorCuentaOrdenante: '',
    CuentaOrdenante: '',
    EsActivo: true
  };
}
